<template>
  <section class="style">
    <h3 class="style__balloon">
      <img
        :src="require(`@/assets/images/${resultCode}-style-balloon.svg`)"
        width="206"
        height="54.5"
        :alt="`${resultName}`"
      >
    </h3>
    <h2 class="style__heading">
      {{ resultName + "スタイル" }}
    </h2>

    <div class="style__content">
      <article
        v-for="item in coordinate"
        :key="item.id"
        class="coordinate"
      >
        <div class="coordinate__image">
          <img
            :src="require(`@/assets/images/${resultCode}-coordinate0${item.id}.png`)"
            width="147"
            height="323"
            :alt="`${resultName}`"
          >
        </div>
        <div class="coordinate__body">
          <h5 class="coordinate__number">
            <img
              :src="require(`@/assets/images/style-title0${item.id}.svg`)"
              width="51"
              height="10"
              :alt="`${resultName}`"
            >
          </h5>
          <h4
            class="coordinate__title"
            v-html="item.title"
          />
          <p class="coordinate__caption">
            {{ item.caption }}
          </p>
        </div>
      </article>
    </div>

    <div class="style__cta">
      <h4 class="style__cta__heading">
        <img
          src="@/assets/images/style-link-title.svg"
          width="186.8068"
          height="16.69"
          alt="きみにおすすめの水着"
        >
      </h4>
      <div class="style__cta__button">
        <a
          :href="cta.link"
          class="link-button link-button--large link-button--negative"
          target="_blank"
        >
          “{{ cta.brand }}”をCHECK！
        </a>
      </div>
    </div>
  </section>
</template>

<script>
export default {
  name: 'ResultStyle',
  props: {
    resultCode: {
      type: String,
      default: ''
    },
    resultName: {
      type: String,
      default: ''
    },
    coordinate: {
      type: Array,
      default: () => []
    },
    cta: {
      type: Object,
      default: () => {}
    },
  }
}
</script>

<style lang="scss" scoped>
@use "@/assets/scss/foundation/config/colors";
@use "@/assets/scss/foundation/config/mediaquery";
@use "@/assets/scss/foundation/mixin";


.style__balloon img {
  @include mediaquery.minMediaMajor {
    width: 298px;
    height: auto;
  }
}

.style__heading {
  margin-top: 10px;
  @include colors.TextYellow;
  font-size: 2.4rem;
  @include mediaquery.minMediaMajor {
    margin-top: 20px;
    font-size: 4rem;
  }
}

.style__content {
  margin: 30px auto 0;
  padding: 0 30px;
  text-align: left;
  @include mediaquery.minMediaExLarge {
    display: grid;
    grid-template-columns: repeat(2, 1fr);
    gap: 70px;
    max-width: 1124px;
    padding: 0 100px;
  }
}


.style__cta {
  margin-top: 35px;
  @include mediaquery.minMediaMajor {
    margin-top: 72px;
  }
}

.style__cta__heading img {
  @include mediaquery.minMediaMajor {
    width: 281.8331px;
    height: 25.18px;
  }
}

.style__cta__button {
  margin-top: 12px;
  @include mediaquery.minMediaMajor {
    margin-top: 20px;
  }
}


.coordinate {
  display: flex;
  @include mediaquery.maxMediaExLarge {
    max-width: 860px;
    margin: 0 auto;
  }

  & + & {
    @include mediaquery.maxMediaExLarge {
      margin-top: 25px;
    }
  }
}

.style__content .coordinate:nth-child(2n) {
  @include mediaquery.maxMediaExLarge {
    flex-direction: row-reverse;
  }
  .coordinate__image {
    margin-right: 0;
    margin-left: 15px;
    @include mediaquery.minMediaMajor {
      margin-left: 24px;
    }
    @include mediaquery.minMediaExLarge {
      margin-left: 0;
      margin-right: 24px;
    }
  }
}

.coordinate__image {
  width: 150px;
  flex: 0 0 150px;
  margin-right: 15px;
  @include mediaquery.minMediaMajor {
    width: 250px;
    flex: 0 0 250px;
    margin-right: 24px;
  }

  img {
    width: 100%;
  }
}

.coordinate__body {
  padding-top: 36px;
  @include mediaquery.minMediaMajor {
    padding-top: 64px;
  }
}

.coordinate__number {
  line-height: 1;

  img {
    @include mediaquery.minMediaMajor {
      width: 91.4px;
      height: 18px;
    }
  }
}

.coordinate__title {
  line-height: 1.5;
  margin-top: 12px;
  font-size: 1.4rem;
  @include mediaquery.minMediaMajor {
    margin-top: 25px;
    font-size: 2.3rem;
  }
}

.coordinate__caption {
  margin-top: 10px;
  line-height: 1.7;
  font-size: 1.2rem;
  @include mediaquery.minMediaMajor {
    margin-top: 12px;
    font-size: 2rem;
  }
}
</style>